export default function formatPercent(number) {
  return (number * 100).toFixed(1) + "%";
}
